import create from "zustand";

interface MapState {
  amounts: Record<string, number>;
  setAmount: (id: string, amount: number) => void;
}

const useMapAmount = create<MapState>((set, get) => ({
  amounts: {},

  setAmount: (id: string, amount: number) => {
    if (get().amounts[id] === amount) {
      return;
    }

    set((state) => ({
      amounts: {
        ...state.amounts,
        [id]: amount,
      },
    }));
  },
}));

export default useMapAmount;
